import React from 'react';
import axios from 'axios';
import ajax from '../../helpers/ajax';
import RenderFormOtro from './RenderFormOtro';

export default class ContainerFormPeriodista extends React.Component {
	constructor(props) {
		super(props);
		this.onSubmitCliente = this.onSubmitCliente.bind(this);
		
		this.state = {
			mostrarMensajeDeEnvio:false,
		};
	}

	onSubmitCliente(values){
		axios
			.post('/api/v1/formOtro/',{
				nombreApellido:values.nombreApellido,
				telefono:values.telefono,
				email:values.email,
				localidad:values.localidad,
				mensaje:values.mensaje,
				to:this.props.to
			})
			.then((result) => {
				this.setState({ mostrarMensajeDeEnvio: true })
			}) 
			.catch((err) => console.log(err));
	}

	render(){
		return <RenderFormOtro
					onSubmit={this.onSubmitCliente}
					mostrarMensajeDeEnvio={this.state.mostrarMensajeDeEnvio}
				/>
	}
}